export default function auth ({ next}){
    let user = JSON.parse(localStorage.getItem("user"));
    if(user==null){
        return next({
            name: 'login'
        })
    }
    return next();
}